import Http from '../http/tmed';
import HttpPartner from '../http/partner';
import HttpQueue from '../http/tmed-queue';
import { environments } from '../config/configManager';
import { serialize } from '@/utils';
import { getSubscriberSuffix } from '@/utils/app-mode';

export const calendar = (params) => Http.get(`/calendar${getSubscriberSuffix()}${serialize(params)}`);
export const fetchDoctors = (occupation, patientAge) => {
  const params = { limit: 1000, status: 'ativo' };
  if (patientAge != null && patientAge !== '') {
    params.patientAge = patientAge;
  }
  return Http.get(`/doctors/${occupation}${getSubscriberSuffix()}${serialize(params)}`);
};
export const fetchOccupations = () => Http.get(`/tmed/config${getSubscriberSuffix()}`);
export const fetchPeriodsAvailable = (params) => Http.get(`/period${getSubscriberSuffix()}${serialize(params)}`);
export const schedule = (params) => Http.post(`/calendar${getSubscriberSuffix()}`, params);
export const scheduleWeekly = (params) => Http.post(`/calendar/weekly${getSubscriberSuffix()}`, params);
export const reschedule = (params) => Http.put(`/calendar${getSubscriberSuffix()}`, params);
export const cancel = (params) => Http.delete(`/calendar/${params.cpf}/${params.scheduleId}${getSubscriberSuffix()}`);
export const fetchSchedulesHistory = (params) => Http.get(`/schedule/all/${params.cpf}${serialize(params.query)}`);
// QUEUE
export const enterQueue = (params) => Http.post(`/queue/wait${getSubscriberSuffix()}`, params);
export const cancelQueue = (params) => Http.delete(`/queue/${params}${getSubscriberSuffix()}`);
export const checkQueue = (params) => Http.get(`/queue${getSubscriberSuffix()}${serialize(params)}`);
export const avaliation = (payload) =>
  HttpPartner.post(`meetings/avaliation/meets-code/${payload.meets}`, {
    ...payload,
  });
export const sendFile = (payload) => Http.post(`/create/patient/docs${getSubscriberSuffix()}`, payload);

export const listPatientDocs = (room) => {
  const encodedRoom = encodeURIComponent(room);
  return Http.get(`/patient/docs/${encodedRoom}${getSubscriberSuffix()}`);
};

// OVERBOOK QUEUE
export const enterOverbookQueue = (params) =>
  HttpQueue.post(`/doctor/queue/enter${getSubscriberSuffix()}`, params);
export const quitOverbookQueue = (params) =>
  HttpQueue.delete(`/doctor/queue/leave/${params.cpf}/${params.doctorId}${getSubscriberSuffix()}`);

export const wsUrl = environments.socket;
